import React from 'react'
import PropTypes from 'prop-types'

import * as Styled from './EnrollmentHero.styles'

const EnrollmentHero = ({ type, image, darkText, children, ...props }) => {
  const split = type === 'Split'

  return (
    <Styled.EnrollmentHero split={split} darkText={darkText} {...props}>
      <Styled.Content split={split}>{children}</Styled.Content>
      {image && <Styled.BackgroundImage src={image} split={split} />}
    </Styled.EnrollmentHero>
  )
}

EnrollmentHero.defaultProps = {
  type: 'Default',
  darkText: true,
}

EnrollmentHero.propTypes = {
  children: PropTypes.node.isRequired,
  image: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['Default', 'Split']),
  darkText: PropTypes.bool,
}

export default EnrollmentHero
